export default __webpack_public_path__ + "static/media/ahmad.c59bcd41.jpg";